<section>
  <div class="notification-header">
    {{notificationAggregator}}
  </div>
  <div box direction="row" gap="small" class="notification-container">
    @for (item of inAppNotificationsData; track item) {
      <mat-card
        [ngClass]="{'notification-card': true, 'notification-card-active': !item?.isRead,'notification-card-notactive': item?.isRead }">
        <mat-card-content>
          <div box direction="row">
            <span class="notification-content">
              <div [innerHTML]="renderSafeHtml(item.notificationSafeHtml!, item.content)"></div>
            </span>
          </div>
          <div box direction="row" align="center" justify="between" class="notification-type">
            <div box direction="row" gap="xsmall"
              [ngClass]="{'notification-type-active': !item?.isRead,'notification-type-notactive': item?.isRead }">
              <span>{{item.createdOn | timeElapsed }}</span>
              <span class="divider">-</span>
              <span> {{item.type}} </span>
            </div>
            <div box direction="row" gap="xsmall" class="xs" align="center">
              @if (item.content && item.content.filterId) {
                <button class="view-shared-btn" mat-flat-button color="primary" (click)="moveToPipeline(+item.content.filterId)">{{ 'sharedNav.appNotificationsContent.viewSharedData' | transloco }}</button>
              }
              @if (!item.isRead) {
                <button mat-icon-button class="mark-as-read xs" (click)="onMarkAsRead(item.id)"
                  [matTooltip]="'sharedNav.appNotificationsContent.markAsRead' | transloco" [matTooltipPosition]="'above'">
                  <mat-icon mat-list-icon svgIcon="MarkAsRead"> </mat-icon>
                </button>
              }
              @if (item.isRead) {
                <button mat-icon-button class="mark-as-read xs" (click)="onMarkAsUnRead(item.id)"
                  [matTooltip]="'sharedNav.appNotificationsContent.markAsUnread' | transloco" [matTooltipPosition]="'above'">
                  <mat-icon mat-list-icon svgIcon="MarkAsRead"> </mat-icon>
                </button>
              }
              <button mat-icon-button class="delete-button xs" (click)="onDelete(item.id)" [matTooltip]="'shared.common.delete' | transloco"
                [matTooltipPosition]="'above'">
                <mat-icon mat-list-icon svgIcon="trash"> </mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>
</section>